import { Box, Text, Table } from '@chakra-ui/react';
import { SortOrder } from '@duke-hq/lib/pagination';
import type { BillableRow } from './types';
import { BillableItemsTableHeader } from './BillableItemsTableHeader';
import { BillableItemsTableBody } from './BillableItemsTableBody';

interface BillableItemsTableProps {
  rows: BillableRow[];
  error?: string | null;
  canManageXeroInvoices?: boolean;
  isAllSelected: boolean;
  isIndeterminate: boolean;
  toggleSelectAll: () => void;
  selectedIdsVisible: Set<string>;
  toggleSelect: (id: string) => void;
  getProviderName: (providerId: string) => string | null;
  openDetails: (id: string) => void;
  orderBy?: string;
  sort?: SortOrder;
  onSort: (columnName: string) => void;
}

export function BillableItemsTable({
  rows,
  error,
  canManageXeroInvoices,
  isAllSelected,
  isIndeterminate,
  toggleSelectAll,
  selectedIdsVisible,
  toggleSelect,
  getProviderName,
  openDetails,
  orderBy,
  sort,
  onSort,
}: BillableItemsTableProps) {
  return (
    <Box flex="1" overflowY="auto" borderRadius="md">
      {error != null ? (
        <Text color="red.500" p={4}>
          {error}
        </Text>
      ) : (
        <Table variant="simple" size="md" minWidth="1100px">
          <BillableItemsTableHeader
            canManageXeroInvoices={canManageXeroInvoices}
            isAllSelected={isAllSelected}
            isIndeterminate={isIndeterminate}
            toggleSelectAll={toggleSelectAll}
            hasRows={rows.length > 0}
            orderBy={orderBy}
            sort={sort}
            onSort={onSort}
          />
          <BillableItemsTableBody
            rows={rows}
            canManageXeroInvoices={canManageXeroInvoices}
            selectedIdsVisible={selectedIdsVisible}
            toggleSelect={toggleSelect}
            getProviderName={getProviderName}
            openDetails={openDetails}
          />
        </Table>
      )}
    </Box>
  );
}
